// extracted by mini-css-extract-plugin
export var arrow = "yizyC";
export var dialog = "_2sBQR";
export var files = "Qfaya";
export var link = "eeU8v";